module.exports = __webpack_public_path__ + "static/media/dossam.8ab946a3.jpg";